import config from "../../../config"; // Pages

import { PackageDetailsPage } from "./details";
export var Routes = [{
  // TODO find another fix for kiosk react-router params
  // path: config.routes.get("houseandland"),
  path: "".concat(config.routes.get("houseandland"), "/:slug+"),
  component: PackageDetailsPage // exact: true

}];
export * from "./details";